<template>
  <div>
    <div class="debugger-nav">
      <TnLink :to="{ name: 'debugger-ui' }" text="Browse UI screens" arrow-right />
    </div>
    <DebuggerConfig />
  </div>
</template>

<script setup lang="ts">
import { TnLink } from '@telenornorgeinternal/telegrafen-vue3-core';

import DebuggerConfig from '@/components/DebuggerConfig.vue';
</script>

<style scoped>
.debugger-nav {
  max-width: 576px;
  margin-inline: auto;
  padding-top: 24px;
  padding-inline: 16px;
  text-align: center;
}
</style>
